var _circle, _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    stroke: "#CDCDCD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6342 5.07181L17.3662 6.07181L10.3248 18.2679L8.70322 19.0766L8.59275 17.2679L15.6342 5.07181Z",
    stroke: "#CDCDCD",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.7012,
    y1: 7.41988,
    x2: 16.2992,
    y2: 8.91988,
    stroke: "#CDCDCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.36437c0bba2e72965b5e00e59625e662.svg";
export { ForwardRef as ReactComponent };